import React from 'react';
import Buttons from '../Buttons/Buttons';
import menuwords from './menuDictionary';
import { languageSwitch } from '../../dictionary/translateFunctions';
import './menu.css';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { cvDownload, cvDownload_en } from '../../conexiones/varConexiones';
/* import { Button } from 'react-scroll'; */
import LangSwitch from '../languageSwitch/langSwitch.js';

const Menu = ({scroll, refs, requestScroll}) => {
    const { mainRef, expRef } = refs;
    const lang = useSelector((state) => state.lang.lang);
    const location = useLocation();
    const navigate = useNavigate();
    const dictionary = menuwords;

    const safeRequestScroll = (target, route = null) => {
        if (route) {
            navigate(route);
        }

        if (typeof requestScroll === 'function') {
            requestScroll(target);
            return;
        }

        if (typeof scroll === 'function') {
            const ref = target === 'exp' ? expRef : target === 'main' ? mainRef : null;
            if (target === 'reset') {
                scroll('reset');
                return;
            }
            scroll(ref);
        }
    };

    const resumFunc = () => {
        const link = document.createElement("a");
        const ruta = lang === 'es' ? cvDownload : cvDownload_en;
        link.href = ruta;
        link.download = "";   // permite descargar el archivo
        link.target = "_blank";
        link.click();
    }
    return(
        <div id="menu_options" className="header_menu">
            <ul id="menu_options" className="header_menu_options">
                <Buttons
                    onClick={() => safeRequestScroll('reset', '/Home')}
                    type={'ghost'}
                    cta={languageSwitch(dictionary.ht0,lang)}
                />
                <Buttons
                    onClick={() => safeRequestScroll('main', '/Home')}
                    type={'ghost'}
                    cta={languageSwitch(dictionary.ht1,lang)}
                />
                {/* <Link className='Link' to="/About"><Buttons onClick={()=>setPosition('about')} type={'ghost'} cta={languageSwitch(dictionary.ht2,lang)} /></Link> */}
                <Buttons
                    onClick={() => safeRequestScroll('exp', '/About')}
                    type={'ghost'}
                    cta={languageSwitch(dictionary.ht2,lang)}
                />
                <Buttons
                    onClick={() => safeRequestScroll('contact', '/Contacto')}
                    type={'ghost'}
                    cta={languageSwitch(dictionary.ht3,lang)}
                />
                <Buttons onClick={()=>resumFunc()} type={'secondary'} cta={languageSwitch(dictionary.ht4,lang)} />
            </ul>
            <LangSwitch/>
        </div>
    )
}

export default (Menu);